import { Component, OnInit, Inject, Type } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { AccountsService, SidePanelService } from '@lib/services';
import { BaseComponent } from '@lib/components';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiResponseError, IAccount, IAuthResponse, UserType } from '@lib/interfaces';
import { CustomersService } from '@lib/services/customer/customer.service';
import { ThemeService } from 'src/theme';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { ETransferFlow } from '@pages/send-money/tenant6/components/transfer-money/transfer-money.component';

@Component({
    template: '',
})
export class SharedBeneficiarySelectionComponent extends BaseComponent implements OnInit {
    mobileControl = new FormControl('', [Validators.required, this.validatePhoneNumber()]);
    loading = false;
    userInfo: IAuthResponse['admin'] = JSON.parse(localStorage.getItem('userInfo') || '');
    senderAccounts: Array<any>;
    allowedCountriesInPhoneSearch: string[];
    redirectToComponent: Type<any>;
    user_type: UserType | string = '';

    constructor(
        public dialogRef: MatDialogRef<SharedBeneficiarySelectionComponent>,
        private readonly sidePanel: SidePanelService,
        private customersService: CustomersService,
        public readonly snackbar: MatSnackBar,
        private accountService: AccountsService,
        @Inject(MAT_DIALOG_DATA) public data: { selectedTransferType: ETransferFlow; account: IAccount[] },
        private themeService: ThemeService,
    ) {
        super();
    }

    ngOnInit() {
        this.allowedCountriesInPhoneSearch = this.themeService.getActiveThemeAssets('allowedCountriesInPhoneSearch');
        this.senderAccounts = this.data?.account ? this.data.account : [];
    }

    continueToPeerToPeerTransaction() {
        this.mobileControl.markAsTouched();
        this.mobileControl.markAsDirty();

        if (this.userInfo.mobile === this.mobileControl.value) {
            const error = new Error('Please do not enter your mobile number');
            this.createApiErrorSnackBar(this.snackbar, error);
            return;
        }

        if (this.mobileControl.valid) {
            let clientName = this.themeService.getActiveThemeAssets('clientName');
            if(clientName =='INC')
                this.user_type ='INDIVIDUAL';
            this.loading = true;
            this.addSubscription(
                this.customersService.filterCustomers({ mobile: this.mobileControl.value || '', user_type: this.user_type as any }).subscribe((response) => {
                    if (response.data.length > 0) {
                        this.accountService.getAccountsByUserId(response.data[0].id || '').subscribe({
                            next: ({ data: accounts }) => {
                                if (
                                    accounts.length === 0 ||
                                    accounts.filter((account) => {
                                        return account.type === 'MASTER';
                                    }).length === 0
                                ) {
                                    const error = new Error('No accounts found for this recipient');
                                    this.createApiErrorSnackBar(this.snackbar, error);
                                    this.loading = false;
                                    return;
                                }
                                this.dialogRef.close();
                                const dialogRef = this.sidePanel.open(this.redirectToComponent, { data: { ...this.data } });
                                dialogRef.componentInstance.recipientInfo = response.data[0];
                                dialogRef.componentInstance.senderAccounts = this.senderAccounts;
                                dialogRef.componentInstance.recipientAccounts = accounts.filter((account) => {
                                    return account.type === 'MASTER';
                                });
                            },
                            error: (error: ApiResponseError) => {
                                this.createApiErrorSnackBar(this.snackbar, error);
                            },
                        });
                    } else {
                        const error = new Error('Recipient not found');
                        this.createApiErrorSnackBar(this.snackbar, error);
                    }
                    this.loading = false;
                }),
            );
        }
    }

    backToTransferMoney() {
        this.dialogRef.close();
        // this.sidePanel.open(TransferMoneyComponent);
    }

    validatePhoneNumber(): (control: AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const phoneNumber = control.value;

            if (!phoneNumber) {
                return null;
            }

            if (!this.allowedCountriesInPhoneSearch || this.allowedCountriesInPhoneSearch.length === 0) {
                return null;
            }

            try {
                const allowedCountriesInPhoneSearch = this.allowedCountriesInPhoneSearch.map((countryCode) => {
                    return countryCode.toUpperCase();
                });

                if (allowedCountriesInPhoneSearch.includes(parsePhoneNumberFromString(phoneNumber as string)?.country || '')) {
                    return null;
                } else {
                    return { validatePhoneNumber: true };
                }
            } catch (error) {
                return { validatePhoneNumber: true };
            }
        };
    }
}
